/**
 * Switch content based on the selected tab.
 */
import {Alert} from '@wandb/weave/components/Alert';
import React from 'react';

import {Analytics} from '../../../services/analytics';
import {useViewer} from '../../../state/viewer/hooks';
import {useAdminModeActive} from '../../../util/admin';
import {Agent} from '../utilTypes';
import {TabLogs} from './TabLogs';
import {TabOverview} from './TabOverview';

type AgentDetailTabContentProps = {
  entityName: string;
  agent: Agent;
  tab: string;
};

export const AgentDetailTabContent = ({
  entityName,
  agent,
  tab,
}: AgentDetailTabContentProps) => {
  Analytics.track(`clicked tab: ${tab}`, {
    tab,
    agent,
    location: 'agent detail',
  });
  const viewer = useViewer();
  const isAdminModeActive = useAdminModeActive();

  const teamNames = viewer?.teams.edges.map(edge => edge.node.name) ?? [];
  const viewerIsMember = teamNames.includes(entityName);
  const showLogs = viewerIsMember || isAdminModeActive;

  return (
    <>
      {tab === 'overview' && (
        <TabOverview entityName={entityName} agent={agent} />
      )}
      {tab === 'logs' &&
        (showLogs ? (
          <TabLogs entityName={entityName} agent={agent} />
        ) : (
          <Alert severity="info">
            Logs for this agent are only available to entity members.
          </Alert>
        ))}
    </>
  );
};
